type ISize = 'md' | undefined
export const generateFonts = (size?: ISize) => {
  switch (size) {
    case 'md': {
      return 'text-[34px] desktop:text-[44px]'
    }
    default: {
      return 'text-[34px] laptop:text-[40px] desktop:text-[54px] large:text-[64px]'
    }
  }
}
